import { render, staticRenderFns } from "./PageToken.vue?vue&type=template&id=db2bb32e"
import script from "./PageToken.vue?vue&type=script&lang=js"
export * from "./PageToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports